/** Sérialise les mises à jour d’un même conteneur (évite les courses de rendu). */
const hostQueues = new WeakMap<HTMLElement, Promise<void>>();

export function enqueueHostRender(
  host: HTMLElement,
  task: () => void | Promise<void>
): Promise<void> {
  const previous = hostQueues.get(host) ?? Promise.resolve();
  const next = previous.catch(() => undefined).then(() => task());
  hostQueues.set(
    host,
    next.catch(() => undefined)
  );
  return next;
}

/** Tests uniquement. */
export function clearHostRenderQueue(host: HTMLElement): void {
  hostQueues.delete(host);
}
